import React from 'react'
import style from './sec2.module.css'
import personIcon from './person.png'
import computerIcon from './computer.png'
import keyBoardIcon from './keyboard.png'
import clockIcon from './clock.png'
import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
const Sec2 = () => {
    const nav = useNavigate()
    return (
        <div dir='rtl' className={style.box}>
                 <div className={style.btnBox}>
                    <Button onClick={() => {
                        window.scrollTo(0, document.body.scrollHeight - 1500);
                    }} variant='contained' className={style.syllabusBtn}>לבדיקת התאמה ופרטים</Button>
                </div>
            <div className={style.container}>
                <div className={style.row}>
                    <div className={style.icon}>
                        <img src={computerIcon} alt="computerIcon" />
                    </div>
                    <div>
                        <h1 className={style.extraBold} >מסלול ההכשרה</h1>
                        <p className={style.extraBold}>• אפשרות לקבלת מימון עד 70% על ידי המדינה.
</p>
                        <p >•  <strong className={style.extraBold}>מבנה מפואר</strong> במרחק הליכה מתחנת עזריאלי </p>
                        <p>• לימוד <strong className={style.extraBold}>יסודות מדעי המחשב</strong>  ועקרונות פיתוח תוכנה בנוסף לתכני <strong className={style.extraBold}>fullstack</strong> </p>
                        <p>• בניית  <strong className={style.extraBold}> תיק עבודות</strong>  ופרוייקט סיום אשר יכין אתכם לשוק</p>
                        <p>•  <strong className={style.extraBold}> bootcamp</strong>  בסוף ההכשרה בליווי מנטורים וראשי צוותים מהתעשייה</p>
                        <p>• גישה חינם  <strong className={style.extraBold}> לאלפי שעות</strong> של הרצאות וידאו במערכת הonline שלנו </p>
                        <p >•  <strong className={style.extraBold}> בתום ההכשרה </strong>  מתחילים להיחשף למעסיקים ולהתראיין במספר בחברות מובילות </p>
                        <p >•    אפשרות ללימודי  <strong className={style.extraBold}>בוקר או ערב</strong></p>

                    </div>

                </div>
                {/* <div className={style.row}>
                    <div className={style.icon}>
                        <img src={personIcon} alt="personIcon" />
                    </div>
                    <div>
                        <h1 className={style.extraBold} >מי הם אנשי FULLSTACK</h1>
                        <p>• המונח DevOps הינו שילוב של Development ו-Operations. הכשרת DevOps Engineer משלבת את כל תחומי האחריות באמצעות לימוד כלים אוטומטיים, והכשרה בתחום התשתיות הענן ואבטחת מידע. בשנים האחרונות גבר הביקוש לתפקיד ה-DevOps במיוחד עם המעבר לעבודה מרחוק.</p>
                        <p className={style.bold}>• על איש DEVOPS להיות בעל יכולת לפתרון תקלות בזמן אמת יצירתיות ויכולת לחקור בעיות ופתרונות. התפקיד כולל תחומי אחריות רבים מגוונים אשר דורשים מגע עם כל חלקי הארגון.</p>
                        <p>• השכר ההתחלתי גבוה ואפשרויות הקידום גבוהות.</p>
                    </div>
                </div> */}



                <div className={style.btnBox}>
                    <Button onClick={() => nav('/syllabus')} variant='contained' className={style.syllabusBtn}>לצפיה בסילבוס התכנית</Button>
                </div>

                <div className={style.rowIcons}>
                    <div className={style.boxIcon}>
                        <div >
                            <h4 className={style.extraBold} >תנאי קבלה</h4>
                            <p>• מבחן התאמה</p>
                            <p>• ראיון אישי</p>

                        </div>
                        <div className={style.iconButtom}>
                            <img src={keyBoardIcon} alt="keyBoardIcon" />
                        </div>
                    </div>
                    <div className={style.boxIcon}>
                        <div >
                            <h4 className={style.extraBold} >משך הכשרה</h4>
                            <p>• 28 שבועות  </p>
                        </div>
                        <div className={style.iconButtom}>
                            <img src={clockIcon} alt="clockIcon" />
                        </div>
                    </div>
                </div>
            </div>


        </div>
    )
}

export default Sec2